import linkRuleHover from '../../../common/algorithms/link-rule-hover';

const secondary = (params) => linkRuleHover(params);

export default secondary;
